import * as React from 'react';

const MOBILE_BREAKPOINT = 768;
const TRUTHY_QUERY_VALUES = ['1', 'true', 'yes', 'on'];

const isWebviewMode = () => {
  if (typeof window === 'undefined') return false;

  const webviewParam = new URLSearchParams(window.location.search)
    .get('webview')
    ?.toLowerCase();

  return TRUTHY_QUERY_VALUES.includes(webviewParam || '');
};

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < MOBILE_BREAKPOINT || isWebviewMode();
  });

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(mql.matches || isWebviewMode());
    };
    mql.addEventListener('change', onChange);
    setIsMobile(mql.matches || isWebviewMode());
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
